module.exports = __webpack_public_path__ + "img/ResgateSeuCupom.900ec693.png";